module.exports = __webpack_public_path__ + "/img/3d8fb5484d73e9007d6b57bbbadb891b.png";